import { render, staticRenderFns } from "./videoLive.vue?vue&type=template&id=72c468fd&scoped=true"
import script from "./videoLive.vue?vue&type=script&lang=js"
export * from "./videoLive.vue?vue&type=script&lang=js"
import style0 from "./videoLive.vue?vue&type=style&index=0&id=72c468fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c468fd",
  null
  
)

export default component.exports